import React from "react";
import { GraduationCap, BookMarked, Languages, User2, Wallet } from "lucide-react";

export default function WhyStudyInRussia() {
  const reasons = [
    {
      icon: <GraduationCap className="w-12 h-12 text-[#C67B3E]" />,
      title: "Top-class Degree Recognized Worldwide",
      description:
        "Higher education in Russia is among the greatest in the world! You can take advantage of Russia’s rich and illustrious academic legacy, particularly in engineering and science. Employers all throughout the world hold a Russian university diploma in high regard.",
    },
    {
      icon: <BookMarked className="w-12 h-12 text-[#C67B3E]" />,
      title: "A Diverse Range of Study Opportunities",
      description:
        "There is something for everyone in Russia’s higher education system! In Russia, there are almost 450 state-accredited colleges offering 17,500-degree programs. Degree programs in every field and academic level are available in Russian universities.",
    },
    {
      icon: <Languages className="w-12 h-12 text-[#C67B3E]" />,
      title: "Learn a New Language",
      description:
        "Russian is one of the world’s ten most widely spoken languages. Russian is spoken by around 400 million people worldwide. It also looks excellent on a résumé if you know a foreign language. Although Russian is a simple language, there are various ways to learn it, including taking a course.",
    },
    {
      icon: <User2 className="w-12 h-12 text-[#C67B3E]" />,
      title: "Live in a Diverse Culture",
      description:
        "Russia’s population is made up of people from over 160 different ethnic groups that speak over 100 different languages. The official language of the country is Russian, which is spoken by the majority of the population, but Tatar and Ukrainian are also widely spoken. Students who are unsure why they should study in Russia are drawn to the culturally diverse environment generated by the country’s people.",
    },
    {
      icon: <Wallet className="w-12 h-12 text-[#C67B3E]" />,
      title: "Affordable Tuition Fees",
      description:
        "The government provides significant funding to the majority of Russian universities. At public universities, bachelor’s degree programs are normally tuition-free. Tuition costs are required for some master’s degree programs, but they are not as expensive as in other countries.",
    },
  ];

  return (
    <section className="w-full bg-[#3D1F14] text-white py-16 px-4 sm:px-6 lg:px-16">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#C67B3E] mb-12">
          Why Study in Russia?
        </h2>

        <div className="flex flex-col gap-14">
          {reasons.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center gap-4"
            >
              <div className="transition-transform duration-300 hover:scale-110">
                {item.icon}
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-[#C67B3E]">
                {item.title}
              </h3>
              <p className="text-gray-200 text-sm sm:text-base max-w-3xl mx-auto leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
